import React from "react";
import PropTypes from "prop-types";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "../css/index.css";
const ClassesContext = /*#__PURE__*/React.createContext(styles);
export const ThemeProvider = _ref => {
  let {
    children,
    classes: classesProp
  } = _ref;
  const classes = useClasses(styles, classesProp);
  return /*#__PURE__*/React.createElement(ClassesContext.Provider, {
    value: classes
  }, children);
};
process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = {
  children: PropTypes.node,
  /**
   * Class dependencies
   */
  classes: classesPropType()
} : void 0;
export const useButtonClasses = override => {
  const contextClasses = React.useContext(ClassesContext);
  const ownClasses = useClasses(styles, override);
  if (override !== undefined) {
    return ownClasses;
  }
  return contextClasses;
};